module.exports = __webpack_public_path__ + "static/media/qr-code-sharp.db7597d6.svg";